import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { authService } from '@/services/auth-service';
import { validateRedirectPath } from '@/utils/redirect-validation';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    authService.handleOAuthCallback()
      .then(() => {
        // Honor ?redirect= from the magic-link / OAuth round-trip (M58 F12 Mode A fix).
        // validateRedirectPath guards against open-redirect; falls back to '/' for any
        // path not matching the /invite/<uuid> or /redeem?token=<uuid> allowlist.
        const redirect = searchParams.get('redirect');
        navigate(validateRedirectPath(redirect), { replace: true });
      })
      .catch(() => navigate('/auth?error=oauth_failed', { replace: true }));
  // searchParams intentionally omitted from deps: the redirect param is read
  // once when the effect fires (mount). Stale closure is safe here because the
  // callback page only ever mounts once per OAuth round-trip.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg)]">
      <div className="text-[var(--color-text-muted)] text-body-sm">Signing you in…</div>
    </div>
  );
}
